import type { OrderLineItemProductName } from "@/types";

import { readString } from "../utils/opensearch-source-readers";

function mapOpenSearchSourceToProductName(
    source: Record<string, unknown>,
): OrderLineItemProductName | null {
    const id = readString(source, "id", "product_id", "sku");
    const name = readString(source, "name", "menuTitle", "title");

    if (!id || !name) {
        return null;
    }

    return { id, name };
}

export { mapOpenSearchSourceToProductName };
